import React, {useEffect, useState, Fragment} from 'react';

import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import SpinnerDiv from "root/Components/SpinnerDiv";
// import bootbox from "bootbox";
import PropTypes from "prop-types";
import {createNewOrganisation, getOrganisationDetails, updateOrganisationDetails} from "root/DataFunctions/OrganisationDataFns";

import DropdownOrganisationTypes from "root/ReactHookForm/ui/DropdownOrganisationTypes";
import DropdownUserTypes from "root/ReactHookForm/ui/DropdownUserTypes";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

const ModalOrganisation = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});
    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete';
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const submitButtonText = () => {
        switch (props.mode)
        {
            case 'view':
                return 'Close';
                break;

            case 'edit':
                return 'Submit';
                break;

            case 'create':
                return 'Submit';
                break;

            case 'delete':
                return 'Delete';
                break;
        }
    };

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                organisation: {
                    organisation_type_id: null,
                    name: '',
                    description: '',
                    website: '',
                    phone: '',
                    contact: '',
                    has_messaging: true,
                    has_lifestory: true
                }
            }
        });

    useEffect(() =>
    {
        if (data.isLoading === false)
        {
            setFocus("organisation.name");
        }
    }, [data.isLoading]);

    const titles = {
        view: 'View Organisation Details',
        edit: 'Edit Organisation Details',
        create: 'New Organisation',
        delete: 'Delete Organisation'
    };

    useEffect(() =>
    {
        if (props.organisation_id !== null)
        {
            getData();
        }
        else
        {
            if (props.mode === 'create')
            {
                setData({isLoading: false, data: []});
            }
        }

    }, []);

    const getData = () => {
        if (isFetchRequired)
        {
            getOrganisationDetails(props.organisation_id, (response) =>
            {
                let orgData = getDataFromResponse(response)[0];
                const has_messaging = +orgData.has_messaging === 0 ? false :true;
                const has_lifestory = +orgData.has_lifestory === 0 ? false :true;

                setValue('organisation',
                    {
                        organisation_type_id: {value: orgData.organisation_type_id}, /* This field uses raw dropdown-select objects */
                        name: orgData.name,
                        description: orgData.description,
                        website: orgData.website,
                        email: orgData.email,
                        phone: orgData.phone,
                        contact: orgData.contact,
                        has_messaging: has_messaging,
                        has_lifestory: has_lifestory
                    });
                setData({isLoading: false, data: orgData});
            });
        }
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted('cancel');
        props.onClose();
    }

    const doCreateOrganisation = (formData) =>
    {
        createNewOrganisation(formData, (response) =>
        {
            bootbox.alert({
                size: "small",
                message: 'Organisation has been Created',
                callback: (result =>
                {
                    setButtonDisabled ( false );
                    props.onSaveCompleted('saved');
                    props.onClose();
                })
            })

        });
    }

    const doUpdateOrganisationDetails = (formData) =>
    {
        updateOrganisationDetails(props.organisation_id, formData, (response) =>
        {
            bootbox.alert({
                size: "small",
                message: 'Organisation has been Updated',
                callback: (result =>
                {
                    setButtonDisabled ( false );
                    props.onSaveCompleted('saved');
                    props.onClose();
                })
            })
        });
    }

    const doDelete = (callback) =>
    {
        deleteUser(props.child_id, (response) =>
        {
            props.onSaveCompleted('saved');
            props.onClose();
        });
    }

    const getSubmitButtonText = (mode) =>
    {
        return submitButtonText();
    }

    const getSubmitButtonStyle = (mode) =>
    {
        switch (mode)
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small";
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small";
        }
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonDisabled === false ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}}
                    disabled={buttonDisabled} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i
                className="et-save"/></button>
        )
    }

    const onSubmit = (data, status) => {

        setButtonDisabled ( true );

        switch (props.mode)
        {
            case 'create' :
                doCreateOrganisation(data);
                break;

            case 'edit' :
                doUpdateOrganisationDetails(data);
                break;

            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to archive this User?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const onClickSaveButton = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const Title = (props) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const isViewOnly = props.mode === 'view';

    const validateDropdownOrgType = (val) =>
    {
        if (+val === 0)
        {
            return "You must select an action";
        }
    }

    const renderHookForm = (prop) =>
    {
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '';

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Organisation Name</label>
                                <input readOnly={readOnlyMode} className='form-control' name='organisation.name'
                                       id='name' {...register("organisation.name", {required: true})} />
                                {formErrors.organisation?.name && <ErrorDiv>Please enter a name</ErrorDiv>}
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Contact Name</label>
                                <input readOnly={readOnlyMode} className='form-control' name='organisation.contact'
                                       id='surname' {...register("organisation.contact", {required: true})} />
                                {formErrors.organisation?.contact && <ErrorDiv>Please enter a contact name</ErrorDiv>}
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Organisation Type</label>
                                <DropdownOrganisationTypes readOnly={false} control={control}
                                                           mode={props.mode} name='organisation.organisation_type_id'
                                                           rules={{required: true, validate: validateDropdownOrgType}}
                                                           placeholder='Please select an organisation type'
                                                           isSearchable={true}
                                                           isClearable={true}/>
                                {formErrors.organisation?.organisation_type_id &&
                                    <ErrorDiv>Please select an organisation type</ErrorDiv>}
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Admin Email Address</label>
                                <input readOnly={readOnlyMode} className='form-control'
                                       name='organisation.email' {...register("organisation.email", {required: true})} />
                                {formErrors.organisation?.email &&
                                    <ErrorDiv>Please enter a contact email address</ErrorDiv>}
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Telephone Number</label>
                                <input readOnly={readOnlyMode} className='form-control'
                                       name='organisation.phone' {...register("organisation.phone")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Website URL</label>
                                <input readOnly={readOnlyMode} className='form-control'
                                       name='organisation.website' {...register("organisation.website")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Description</label>
                                <input readOnly={readOnlyMode} className='form-control'
                                       name='organisation.description' {...register("organisation.description")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div>
                                <label>Lifestory Enabled</label>
                                <div style={{marginTop: '5px'}}>
                                    <FormToggle readOnly={false} control={control} name='organisation.has_lifestory'/>
                                    {formErrors.organisation?.has_lifestory &&
                                        <ErrorDiv>{formErrors.organisation.has_lifestory.message}</ErrorDiv>}
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-md-6'>
                            <div>
                                <label>Has Messaging</label>
                                <div style={{marginTop: '5px'}}>
                                    <FormToggle readOnly={false} control={control} name='organisation.has_messaging'/>
                                    {formErrors.organisation?.has_messaging &&
                                        <ErrorDiv>{formErrors.organisation.has_messaging.message}</ErrorDiv>}
                                </div>
                            </div>
                        </div>*/}
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i
                            className="et-arrow-bold-left"/></button>
                        {!isViewOnly && submitButton(props.mode, onClickSaveButton)}
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode}/>
            <div style={{width: props.width}}>
                {data.isLoading && <SpinnerDiv/>}
                {!data.isLoading && renderHookForm()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalOrganisation;

ModalOrganisation.defaultProps = {
    width: '600px'
}

ModalOrganisation.propTypes = {
    organisation_id: PropTypes.number,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};